import React, { useState } from "react";
import { logEvent } from "@shared/analytics/analytics";
import { Manufacturer } from "../../types";
import { Dashboard } from "../dashboard/dashboard";
import { ManufacturersList } from "../list/list";
import { ManufacturerDialog } from "../manufacturerDialogue/manufacturerDialogue";
import { Button } from "@shared/ui/button";
import { Factory, Plus } from "lucide-react";
import { PageHeader } from "@shared/components/PageHeader";

export const Landing = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [editingManufacturer, setEditingManufacturer] =
    useState<Manufacturer | null>(null);

  const handleAddClick = () => {
    setEditingManufacturer(null); // Clear edit data for add mode
    setIsDialogOpen(true);
  };

  const handleEditManufacturer = (manufacturer: Manufacturer) => {
    setEditingManufacturer(manufacturer); // Set edit data for edit mode
    setIsDialogOpen(true);
  };

  const handleDialogClose = () => {
    setIsDialogOpen(false);
    setEditingManufacturer(null);
  };

  return (
    <div className="p-3">
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 bg-indigo-100 rounded-lg flex items-center justify-center">
              <Factory className="h-5 w-5 text-indigo-600" />
            </div>
            <div>
              <PageHeader
                title="Manufacturers Management"
                subtitle="Manage comprehensive list of all equipment and component manufacturers"
              />
            </div>
          </div>
          <div className="flex items-center gap-2">
            <Button
              className="bg-blue-600 hover:bg-blue-700"
              onClick={() => {
                logEvent("manufacturer_add_clicked");
                handleAddClick();
              }}
            >
              <Plus className="h-4 w-4 mr-2" />
              Add Manufacturer
            </Button>
          </div>
        </div>
        {/* Dashboard */}
        <Dashboard />

        {/* Table with Header, Filter, and Pagination integrated */}
        <ManufacturersList
          onEdit={handleEditManufacturer}
          onAdd={handleAddClick}
        />

        {/* Single Dialog for Both Add and Edit */}
        <ManufacturerDialog
          isOpen={isDialogOpen}
          onClose={handleDialogClose}
          editData={editingManufacturer}
        />
      </div>
    </div>
  );
};
